import React from 'react';

interface SpirisIconProps {
    name: string;
    size?: string;
    filled?: boolean;
    className?: string;
}

// Decorative glyph (aria-hidden); use SkynetIconButton for an interactive icon.
export const SpirisIcon = ({ name, size = '', filled = false, className = '' }: SpirisIconProps): React.JSX.Element => {
    const classes = [`spirisicon spirisicon-${name}`, filled ? 'spirisicon-filled' : '', size !== '' ? `spirisicon-${size}` : '', className].filter(Boolean).join(' ');

    return <i className={classes} aria-hidden="true" />;
};

export default SpirisIcon;
